import { useRouter, useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'
import { toast } from '~components/ui/toast'
import { setAppReset } from '~store/reset'

const useRouterBackToTerminate = () => {
  const router = useRouter()
  const routerState = useRouterState()

  useEffect(() => {
    if (
      routerState.location.pathname.includes('/consultation/') ||
      routerState.location.pathname.includes('/submitted')
    ) {
      setAppReset(true)
      window.history.pushState(null, '', '/samsung/smart-things/')

      toast.open({
        type: 'default',
        message: `Tap back again to exit and return to SmartThings.`,
        position: 'bottom',
      })

      window.history.go(-(window.history.length - 1))
    }
  }, [router, routerState.location.pathname])
}

export default useRouterBackToTerminate
